// extracted by mini-css-extract-plugin
module.exports = {"container":"SimpleAuth_container__132IK","button":"SimpleAuth_button__1LdZG"};